module.exports = __webpack_public_path__ + "img/page05_text.a19167ea.png";